import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { CtaButton } from "./CtaButton";

const POINTS = [
  "You love fitness, health + wellness — and you've thought about becoming a creator or influencer yourself",
  "You haven't started yet, because you honestly don't know where to begin",
  "You're already posting, but it feels inconsistent and it's not growing",
  "You're tired of generic social media advice that was never made for someone like you",
  "You want to build something that actually feels like you — faith and all",
];

export const ForYou = () => (
  <section data-testid="for-you-section" className="bg-sand border-y border-line">
    <div className="max-w-6xl mx-auto px-6 py-24">
      <motion.div
        className="max-w-2xl mx-auto text-center"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <p className="font-accent text-2xl text-clay mb-3">quick check</p>
        <h2 data-testid="for-you-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-ink">
          This is for you if…
        </h2>
      </motion.div>
      <div className="mt-12 max-w-2xl mx-auto space-y-4">
        {POINTS.map((point, i) => (
          <motion.div
            key={point}
            data-testid={`for-you-point-${i + 1}`}
            className="flex items-start gap-4 rounded-2xl border border-line bg-white p-5"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
          >
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage">
              <Check className="h-4 w-4 text-white" />
            </span>
            <p className="text-base sm:text-lg text-ink leading-relaxed">{point}</p>
          </motion.div>
        ))}
      </div>
      <motion.div
        className="mt-10 text-center"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <CtaButton testId="mid-cta-button">Save My Free Seat</CtaButton>
      </motion.div>
    </div>
  </section>
);
